import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { setAppId } from '../slices/app';

export default (appId: string) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setAppId(appId));
  }, [dispatch, appId]);
};
